import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

function tabs(selector, navigation) {

    const TABS = Array.from(document.querySelectorAll(selector))

    if(!TABS.length) return

    TABS.forEach((tab) => {

        let config = {
            container: tab,
            items: 1,
            mode: 'gallery',
            controls: false
        }

        if (navigation) config.navContainer = navigation

        tns(config)
    })
}

tabs('.nutrition-tabs--wrapper', '.nutrition-tabs--navigation')
